export default __webpack_public_path__ + "static/media/closeIcon.9b272f29.svg";